import { render } from "./InvestmentsView.vue?vue&type=template&id=b1ceecfe&scoped=true"
import script from "./InvestmentsView.vue?vue&type=script&lang=js"
export * from "./InvestmentsView.vue?vue&type=script&lang=js"

import "./InvestmentsView.vue?vue&type=style&index=0&id=b1ceecfe&lang=scss"
import "./InvestmentsView.vue?vue&type=style&index=1&id=b1ceecfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ceecfe"]])

export default __exports__